<script setup lang="ts">
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import type { NicknameColorType } from '@/types/mall'
import { socketEmit, socketEmitAsync } from '@/utils/web-socket'
import { watch } from 'vue'
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { onMounted } from 'vue'
import { formatNumberWithCommas } from '@/utils'

const userStore = useUserStore()
const commonStore = useCommonStore()

const nicknameColorList = ref<NicknameColorType[]>()
const curNicknameColor = ref<NicknameColorType>()
async function getNicknameColorList() {
  socketEmit<NicknameColorType[]>({
    type: 'getNicknameColorCollection',
    callBack: (res) => {
      nicknameColorList.value = res.data
    },
  })
}
function handleBuyNicknameColor() {
  if (!curNicknameColor.value) return ElMessage.warning('未选中任何商品')
  const { id, name, color, price } = curNicknameColor.value
  if (userStore.diamond < price) return ElMessage.warning('钻石不足')
  ElMessageBox.confirm(`确认购买字体颜色【<span style="color:${color}">${name}</span>】吗？本次购买花费<b>${price}</b>钻石`, '提示', {
    type: 'warning',
    dangerouslyUseHTMLString: true,
    appendTo: 'body',
    confirmButtonClass: 'is-plain',
  })
    .then(async () => {
      await socketEmitAsync({ type: 'buyNicknameColor', data: { id } })
      userStore.diamond -= price
      const index = nicknameColorList.value!.findIndex((item) => item.id === id)
      nicknameColorList.value!.splice(index, 1)
      ElMessageBox.confirm('购买成功，是否立即穿戴？', '提示')
        .then(async () => {
          await socketEmitAsync({ type: 'useNicknameColor', data: { id } })
          userStore.nicknameColor = color
        })
        .catch(() => {})
    })
    .catch(() => {})
}

onMounted(() => {
  getNicknameColorList()
})
</script>

<template>
  <div class="nickname-color">
    <p class="common-coin-info">💎 {{ formatNumberWithCommas(userStore.diamond) }}</p>
    <div class="nickname-color-list-wrap border-wrap">
      <h4>商品列表</h4>
      <div class="nickname-color-list">
        <div class="item" v-for="item of nicknameColorList" :key="item.id">
          <el-button size="small" type="primary" plain @click="curNicknameColor = item">
            <span class="nickname" style="font-weight: bold" :style="{ background: item.color }">{{ item.name }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <div class="nickname-color-detail border-wrap">
      <h4>商品详情</h4>
      <p>名称：{{ curNicknameColor?.name || '未选择' }}</p>
      <p>
        预览：<span class="nickname" :style="{ background: curNicknameColor?.color || 'unset' }">{{ userStore.nickname }}</span>
      </p>
      <p>价格：{{ curNicknameColor?.price || 0 }}💎</p>
      <el-button type="primary" plain style="width: 100%" @click="handleBuyNicknameColor">购入</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.nickname-color {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  .border-wrap {
    padding: 10px;
  }
  .nickname-color-list-wrap {
    flex: 1;
    margin-bottom: 10px;
    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;
    .nickname-color-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      overflow: auto;
      .item {
        width: calc(50% - 5px);
        margin-bottom: 10px;
        button {
          width: 100%;
        }
      }
    }
  }
  .nickname-color-detail {
    p {
      margin: 6px 0;
      font-size: 14px;
    }
  }
  :deep() {
    .el-button:focus,
    .el-button:hover {
      background-color: unset;
    }
  }
}
</style>
